
const messages = {
  en: {
    tamanio: {
      title: 'Tamaño management',
      menuTitle: 'Sizes',
      subtitle: 'View, search, create, edit and delete Tamaño',
      creating: 'Creating Tamaño',
      editing: 'Editing Tamaño',
      deleting: 'Deleting Tamaño',
      showing: 'Showing Tamaño',
      labels: {
        tamanio: 'size (ARG)'
      },
      modals: {
        updateImpact: {
          title: 'Confirm update',
          description: 'Updating this size will affect {productosCount} products in {depositosCount} deposits.',
          confirmQuestion: 'Do you want to continue?',
        },
        deleteImpact: {
          title: 'Confirm delete',
          description: 'Deleting this size will unlink {productosCount} products in {depositosCount} deposits.',
          confirmQuestion: 'Do you want to continue?',
        },
      },
    }
  },
  es: {
    tamanio: {
      title: 'Administración de Tamaño',
      menuTitle: 'Tamaños',
      subtitle: 'Ver, buscar, crear, editar, y borrar Tamaño',
      creating: 'Creando Tamaño',
      editing: 'Modificando Tamaño',
      deleting: 'Eliminando Tamaño',
      showing: 'Detalles de Tamaño',
      labels: {
        tamanio: 'tamaño (ARG)'
      },
      modals: {
        updateImpact: {
          title: 'Confirmar actualización',
          description: 'Actualizar este tamaño afectará {productosCount} productos en {depositosCount} depósitos.',
          confirmQuestion: '¿Desea continuar?',
        },
        deleteImpact: {
          title: 'Confirmar eliminación',
          description: 'Eliminar este tamaño desvinculará {productosCount} productos en {depositosCount} depósitos.',
          confirmQuestion: '¿Desea continuar?',
        },
      },
    }
  },
  pt: {
    tamanio: {
      title: 'Administração de Tamaño',
      menuTitle: 'Tamanhos',
      subtitle: 'Ver, buscar, criar, editar e usar Tamaño',
      creating: 'Criando Tamaño',
      editing: 'Edição Tamaño',
      deleting: 'Apagando Tamaño',
      showing: 'Detalhes do Tamaño',
      labels: {
        tamanio: 'tamanho (ARG)'
      },
      modals: {
        updateImpact: {
          title: 'Confirmar atualização',
          description: 'Atualizar este tamanho afetará {productosCount} produtos em {depositosCount} depósitos.',
          confirmQuestion: 'Deseja continuar?',
        },
        deleteImpact: {
          title: 'Confirmar exclusão',
          description: 'Excluir este tamanho desvinculará {productosCount} produtos em {depositosCount} depósitos.',
          confirmQuestion: 'Deseja continuar?',
        },
      },
    },
  }
}

export default messages
